module.exports = __webpack_public_path__ + "static/media/2.8a89b86e.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/female/accessoires/2.png
// module id = 386
// module chunks = 0